import { createAction, props } from '@ngrx/store';
import { MwLoadOptions } from 'app/models/load-options.model';
import { MwPayloadModel } from 'app/models/payload.model';
import { DriverApiModel } from 'app/models/drivers-api.model';

export const loadDrivers = createAction(
  '[Drivers] Load',
  props<{ loadOptions: MwLoadOptions }>()
);

export const loadDriversSuccess = createAction(
  '[Drivers] Load Successful',
  props<{ response: MwPayloadModel<DriverApiModel[]> }>()
);

export const loadDriversFailed = createAction(
  '[Drivers] Load Failed',
  props<{ error: any }>()
);

export const createDriver = createAction(
  '[Drivers] Create',
  props<{ driver: DriverApiModel }>()
);

export const createDriverSuccess = createAction('[Drivers] Create Successful');

export const createDriverFailed = createAction(
  '[Drivers] Create Failed',
  props<{ error: any }>()
);

export const updateDriver = createAction(
  '[Drivers] Update',
  props<{ driver: DriverApiModel }>()
);

export const updateDriverSuccess = createAction('[Drivers] Update Successful');

export const updateDriverFailed = createAction(
  '[Drivers] Update Failed',
  props<{ error: any }>()
);

export const deleteDriver = createAction(
  '[Drivers] Delete',
  props<{ driver: DriverApiModel }>()
);

export const deleteDriverSuccess = createAction('[Drivers] Delete Successful');

export const deleteDriverFailed = createAction(
  '[Drivers] Delete Failed',
  props<{ error: any }>()
);

export const deleteDriversList = createAction(
  '[Drivers] Delete List',
  props<{ drivers: DriverApiModel[] }>()
);

export const deleteDriversListSuccess = createAction(
  '[Drivers] Delete List Successful'
);

export const deleteDriversListFailed = createAction(
  '[Drivers] Delete List Failed',
  props<{ error: any }>()
);

export const resetDrivers = createAction('[Drivers] Reset');
